// Standard library imports
import React, { useState } from 'react';
// External library imports
import _ from 'lodash';
// CSS Imports
import classes from '../../../styles/CapacityContent.module.css';
import Typography from '../../../components/Typography/Typography';
import { getColumnWithSlotSize } from '../../../utils/biddingHelper';

const HourlyCost = ({ data }) => {
    const length = _.get(data, ['bidStatus'], []).length || 24;
    const slots = Array.from({ length: length }, (__, i) => i);
    const columns = getColumnWithSlotSize(slots, 8);

    return (
        <div className={`${classes.CapacityContent} ${classes.InfoModalContainer}`}>
            {_.get(data, ['bidStatus'], []).length ? (
                <div className={classes.Content}>
                    <Typography content={'Capacity Settlement'} size={14} />
                    <div className={classes.ContainerStart}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Price</th>
                                </tr>
                                <tbody>
                                    {column.map((key) => (
                                        <tr>
                                            <td style={{ display: 'flex', gap: '0.5vw' }}>{_.get(data, ['bidStatus', key, 'productName'], '--')}</td>
                                            <td>{_.get(data, ['bidStatus', key, 'price'], '--')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            ) : (
                ''
            )}
            {_.get(data, ['energyStatus'], []).length ? (
                <div className={classes.Content} style={{ marginTop: '2vh' }}>
                    <Typography content={'Energy Settlement'} size={14} />
                    <div className={classes.ContainerStart}>
                        {columns.map((column, colIndex) => (
                            <table key={colIndex}>
                                <tr>
                                    <th>Product Name</th>
                                    <th>Price</th>
                                    <th>Datahub Cost</th>
                                </tr>
                                <tbody>
                                    {column.map((key) => (
                                        <tr>
                                            <td style={{ display: 'flex', gap: '0.5vw' }}>{_.get(data, ['energyStatus', key, 'productName'], '--')}</td>
                                            <td
                                                style={
                                                    _.get(data, ['energyStatus', key, 'dhCost'], 0).toFixed(2) > _.get(data, ['energyStatus', key, 'price'], 0)
                                                        ? { color: 'red' }
                                                        : {}
                                                }
                                            >
                                                {_.get(data, ['energyStatus', key, 'price'], '--')}
                                            </td>
                                            <td>{_.get(data, ['energyStatus', key, 'dhCost'], 0).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ))}
                    </div>
                </div>
            ) : (
                ''
            )}
        </div>
    );
};

export default HourlyCost;
